import { render, staticRenderFns } from "./bonus.vue?vue&type=template&id=4b51396d&scoped=true"
import script from "./bonus.vue?vue&type=script&lang=js"
export * from "./bonus.vue?vue&type=script&lang=js"
import style0 from "./bonus.vue?vue&type=style&index=0&id=4b51396d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51396d",
  null
  
)

export default component.exports